export const collection = 'cms_category_muscle';
